import { axiosServicesV1 } from 'utils/services';

const notificationData = async () => {
    try {
        const response = await axiosServicesV1.get(`data_iris/D_AnnouncementList`);
        if (response?.data?.pxResults) {
            return response.data.pxResults;
        }
    } catch (error) {
        console.error(error);
    }
    return [];
};

export default notificationData;
